import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import Card from 'components/shared/Card'
import style from './style.styl'

const TitleCard = ({ title, subtitle, className, children }) => (
  <Card className={classNames(style.TitleCard, className)}>
    <div className={"header flex-space-between"}>
      <div className="title">{ title }</div>
      <div className="subtitle">{ subtitle }</div>
    </div>
    <div className="content">
      { children }
    </div>
  </Card>
)
TitleCard.propTypes = {
  title: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
}

export default TitleCard



// WEBPACK FOOTER //
// ./src/scripts/components/shared/TitleCard/index.js